export default __webpack_public_path__ + "images/bgpk4.5a0a929.jpg";